export default "__VITE_ASSET__CKvnWHMf__"